__turbopack_context__.v({
  "className": "vjK-Rq_className",
  "variable": "vjK-Rq_variable",
});
